
import { NavigatorWithConnection } from "./types";

/**
 * Checks if the current device is a mobile device based on screen width
 */
export const isMobileDevice = (): boolean => {
  return window.innerWidth < 768;
};

/**
 * Logs network information for debugging purposes
 */
export const logNetworkInformation = (): void => {
  // Add network information logging for debugging
  // Use type assertion to access the connection property safely
  const nav = navigator as NavigatorWithConnection;
  if (nav.connection) {
    console.log("Network information:", {
      type: nav.connection.type,
      effectiveType: nav.connection.effectiveType,
      downlinkMax: nav.connection.downlinkMax,
      rtt: nav.connection.rtt,
      saveData: nav.connection.saveData
    });
  }
};

/**
 * Normalizes the Frank API URL to ensure proper formatting
 */
export const normalizeApiUrl = (url: string): string => {
  // Normalize the API URL - remove trailing 'ask' if present to prevent double path
  let normalizedUrl = url;
  if (normalizedUrl.endsWith('/ask')) {
    normalizedUrl = normalizedUrl.slice(0, -4); // Remove '/ask' from the end
  }
  
  // Ensure the URL is properly formatted (no double slashes)
  return normalizedUrl.endsWith('/') ? `${normalizedUrl}ask` : `${normalizedUrl}/ask`;
};
